var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m489.715 167.004v284.952c0 26.534-21.51 48.044-48.044 48.044h-296.28c-26.534 0-48.044-21.51-48.044-48.044v-391.912c0-26.534 21.51-48.044 48.044-48.044h198.441z",
    fill: "#ffa785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.714 167.004h-113.853c-17.689 0-32.029-14.34-32.029-32.029v-122.974z",
    fill: "#ff712f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.888 427.607h-371.403c-5.081 0-9.2-4.119-9.2-9.2v-168.324c0-5.081 4.119-9.2 9.2-9.2h371.403c5.081 0 9.2 4.119 9.2 9.2v168.324c0 5.081-4.119 9.2-9.2 9.2z",
    fill: "#ff712f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m134.356 382.919c-1.533 0-2.659-.375-3.347-1.189-.719-.813-1.095-1.814-1.095-2.971 0-1.595.5-3.284 1.47-4.973l41.726-76.539h-36.47c-1.439 0-2.565-.626-3.441-1.908-.845-1.251-1.251-2.69-1.251-4.41 0-1.533.375-2.971 1.126-4.316.782-1.345 1.971-2.033 3.566-2.033h50.171c1.533 0 2.69.407 3.441 1.157.751.782 1.157 1.72 1.157 2.909 0 1.501-.563 3.253-1.626 5.255l-41.694 76.382h40.756c1.533 0 2.69.688 3.503 2.002.782 1.376 1.189 2.815 1.189 4.316 0 1.533-.407 2.971-1.189 4.316-.813 1.345-1.971 2.002-3.503 2.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.708 382.919c-1.814 0-3.441-.375-4.911-1.126s-2.221-1.939-2.221-3.566v-89.05c0-1.626.751-2.784 2.221-3.503s3.097-1.095 4.911-1.095c1.783 0 3.409.375 4.911 1.095 1.47.719 2.221 1.877 2.221 3.503v89.05c0 1.626-.751 2.815-2.221 3.566-1.501.751-3.128 1.126-4.911 1.126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.737 382.919c-1.814 0-3.441-.375-4.911-1.126s-2.221-1.939-2.221-3.566v-89.05c0-1.282.5-2.346 1.533-3.222 1.032-.907 2.377-1.376 3.972-1.376h26.243c5.474 0 10.447 1.001 14.92 2.909 4.504 1.939 8.039 5.067 10.635 9.415s3.91 10.134 3.91 17.297v1.063c0 7.163-1.345 12.949-4.035 17.297s-6.318 7.507-10.916 9.477c-4.567 1.971-9.665 2.971-15.327 2.971h-16.671v33.218c0 1.626-.751 2.815-2.221 3.566-1.501.752-3.128 1.127-4.911 1.127zm7.132-49.232h16.671c5.036 0 8.946-1.439 11.761-4.285 2.846-2.878 4.254-7.288 4.254-13.168v-1.626c0-5.943-1.408-10.322-4.254-13.137-2.815-2.815-6.725-4.223-11.761-4.223h-16.671z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zip.4b4d90c34b02f9b7a7ab5d88ff4e6942.svg";